import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@src/utils/baseQuery";

export const SubOrganizationApiSlice = createApi({
  reducerPath: "subOrganizationApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["getAllSubOrganizations"],
  endpoints: builder => ({
    getAllSubOrganizations: builder.query<
      any,
      { parentId?: string; pageNo: number; pageSize: number; type: string }
    >({
      query: ({ parentId, pageNo, pageSize, type }) => ({
        url: `organization/get-all-organization?type=${type}&pageNo=${pageNo}&pageSize=${pageSize}&parentId=${parentId}`,
        method: "GET",
      }),
      providesTags: ["getAllSubOrganizations"],
    }),
    createSubOrganizations: builder.mutation<
      any,
      { organizationRequest: string; adderEmail: string }
    >({
      query: ({ adderEmail, organizationRequest }) => {
        const formData = new FormData();

        formData.append("organizationRequest", organizationRequest.toString());

        return {
          url: `organization?adderEmail=${adderEmail}`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["getAllSubOrganizations"],
    }),
  }),
});

export const {
  useGetAllSubOrganizationsQuery,
  useLazyGetAllSubOrganizationsQuery,
  useCreateSubOrganizationsMutation,
} = SubOrganizationApiSlice;
